import { motion } from "framer-motion";
import { MaskedLine, EASE } from "../lib/motion";
import { IMAGES } from "../data/content";

const PageHero = ({ eyebrow, title, highlight, description, image }) => (
  <section className="relative pt-40 pb-24 overflow-hidden grain" data-testid="page-hero">
    <div className="absolute inset-0">
      <img src={image || IMAGES.cta} alt="" className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-navy-deep/85 via-navy/80 to-navy-deep" />
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE }}
        className="text-xs sm:text-sm font-semibold tracking-[0.35em] text-gold font-display mb-5"
      >
        {eyebrow}
      </motion.p>
      <h1 className="font-display font-black tracking-tight text-white leading-[1.02] text-4xl sm:text-5xl lg:text-6xl max-w-4xl" data-testid="page-hero-title">
        <MaskedLine delay={0.15}>{title}</MaskedLine>
        {highlight && (
          <MaskedLine delay={0.3}>
            <span className="gold-gradient-text">{highlight}</span>
          </MaskedLine>
        )}
      </h1>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5, ease: EASE }}
          className="mt-6 text-base sm:text-lg text-slate-300 max-w-2xl leading-relaxed"
        >
          {description}
        </motion.p>
      )}
    </div>
  </section>
);

export default PageHero;
